export enum ROLE {
    SuperAdmin = 'super_admin',
    Admin = 'admin',
    Editor = 'editor',
    Viewer = 'viewer'
}